<div role="contentinfo" class="media-width-headerfooter" tabindex="0" [innerHTML]="footerString | headerFooterHtml"></div>